<template>
  <div>
    <v-dialog
      v-model="dialog"
      transition="dialog-top-transition"
      max-width="600"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <!-- NEW Option -->
          <v-icon color="green" v-if="!option">mdi-plus</v-icon>
          <v-icon v-if="option">mdi-cog</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn v-if="!option" dark text @click="create"> CREATE </v-btn>
          <v-btn v-if="option" dark text @click="save"> SAVE </v-btn>
          <v-btn v-if="option" dark text @click="remove"> DELETE </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title> New Option</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="mt-9">
          <v-text-field
            label="Option Name"
            single-line
            v-model="name"
          ></v-text-field>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import fire from "@/main";

export default {
  props: {
    relativePath: {
      default: "",
    },
    option: null,
  },
  data: () => ({
    dialog: false,
    name: null,
    myPath: "",
  }),
  async created() {
    if (this.option) {
      this.name = this.option.value;
    }
  },
  methods: {
    async create() {
      if (this.name != "component") {
        await fire
          .database()
          .ref(`${this.relativePath}/options`)
          .push({ value: this.name });
        this.dialog = false;
      }
    },
    async save() {
      if (this.name != "component") {
        await fire
          .database()
          .ref(`${this.relativePath}`)
          .update({ value: this.name });
        this.dialog = false;
      }
    },
    async remove() {
      await fire.database().ref(`${this.relativePath}`).set(null);
      this.dialog = false;
    },
  },
};
</script>

<style>
</style>